var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('p',{ref:"summaryParagraph",staticClass:"summary mb-0"},[_vm._v("\n      "+_vm._s(_vm.summary)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }